// extracted by mini-css-extract-plugin
module.exports = {"shoppingHeaderContainer":"ShoppingHeader_shoppingHeaderContainer__mugO6","bg":"ShoppingHeader_bg__7v0SS","stylizedHeader":"ShoppingHeader_stylizedHeader__N1BVB"};